import { NoddiAsyncSelect } from '@ui-components/Inputs/NoddiSelect/NoddiAsyncSelect';
import { SelectOption } from '@ui-components/Inputs/NoddiSelect/SelectBase';
import { ComponentProps } from 'react';
import { useFieldContext } from '../formContext';
import { TanstackFieldError } from '../TanstackFieldError';
import { useTanstackFieldAria } from '../useTanstackFieldAria';

type Props<TValue> = Omit<ComponentProps<typeof NoddiAsyncSelect<TValue>>, 'selectedOption' | 'onSelectionChange'> & {
  onSelectionSideEffect?: (option: SelectOption<TValue> | undefined) => void;
};

export const TanstackFormAsyncSelect = <TValue,>({ onSelectionSideEffect, ...rest }: Props<TValue>) => {
  const field = useFieldContext<SelectOption<TValue> | undefined>();
  const fieldAria = useTanstackFieldAria(field, rest['aria-describedby']);

  return (
    <div>
      <NoddiAsyncSelect
        {...rest}
        id={rest.id ?? field.name}
        name={field.name}
        {...fieldAria}
        selectedOption={field.state.value}
        onSelectionChange={(option: SelectOption<TValue> | undefined) => {
          field.handleChange(option);
          onSelectionSideEffect?.(option);
        }}
      />
      <TanstackFieldError field={field} />
    </div>
  );
};
